<app-navbar-style-one></app-navbar-style-one>

<div class="custom-page-header-section">
    <div class="container-fluid">
        <div class="row pt-5">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-content-center align-items-center menu-header-section">
                <div class="ms-5">
                    <h2>Terms </h2>
                    <p class="mt-4 mb-0 mx-3">Welcome to <strong>Fontana</strong> Terms & Conditions. By accessing or using our website, ordering online, or visiting our physical location, you agree to the following terms and conditions. Please read them carefully.</p>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 text-center before-img-section">
                <img src="../../../assets/img/home2/cart.png" alt="Menu Page" class="img-fluid">
            </div>
        </div>
    </div>
</div>

<div class="terms-conditions-area ptb-100">
    <div class="container">
        <div class="single-content">
            <h3>Welcome to FONTANA Terms & Conditions</h3>
            <div class="terms-content" [innerHTML]="settings"></div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>